export default __webpack_public_path__ + "static/media/bg-wire-375x266.5ba0b395.png";